"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortArrayOfObjectsAlphabetically = exports.sortAlphabetically = void 0;
/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */

var sortAlphabetically = function sortAlphabetically(items, sortAZ) {
  // if we're not an array create one
  var itemsArray = Array.isArray(items) ? items : Object.keys(items).map(function (key) {
    return {
      key: key,
      value: items[key]
    };
  }); // return alphabetically sorted items

  return itemsArray.sort(function (a, b) {
    var keys = [a.key, b.key];

    if (sortAZ) {
      // sort A-Z
      if (keys[0] < keys[1]) return -1;else if (keys[0] > keys[1]) return 1;
    } else {
      // sort Z-A
      if (keys[0] > keys[1]) return -1;else if (keys[0] < keys[1]) return 1;
    }

    return 0;
  });
};

exports.sortAlphabetically = sortAlphabetically;

var sortArrayOfObjectsAlphabetically = function sortArrayOfObjectsAlphabetically(items, propToSortBy) {
  return items.sort(function (a, b) {
    return a[propToSortBy].localeCompare(b[propToSortBy]);
  });
};

exports.sortArrayOfObjectsAlphabetically = sortArrayOfObjectsAlphabetically;